import { render, staticRenderFns } from "./itweb-africa.vue?vue&type=template&id=12fda5b6"
import script from "./itweb-africa.vue?vue&type=script&lang=js"
export * from "./itweb-africa.vue?vue&type=script&lang=js"
import style0 from "./itweb-africa.vue?vue&type=style&index=0&id=12fda5b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports